/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePalSubmissionRequest
 */
export interface CreatePalSubmissionRequest {
    /**
     * 
     */
    is_oon: boolean;
}

/**
 * Check if a given object implements the CreatePalSubmissionRequest interface.
 */
export function instanceOfCreatePalSubmissionRequest(value: object): value is CreatePalSubmissionRequest {
    if (!('is_oon' in value) || value['is_oon'] === undefined) return false;
    return true;
}

export function CreatePalSubmissionRequestFromJSON(json: any): CreatePalSubmissionRequest {
    return CreatePalSubmissionRequestFromJSONTyped(json, false);
}

export function CreatePalSubmissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePalSubmissionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'is_oon': json['is_oon'],
    };
}

export function CreatePalSubmissionRequestToJSON(json: any): CreatePalSubmissionRequest {
    return CreatePalSubmissionRequestToJSONTyped(json, false);
}

export function CreatePalSubmissionRequestToJSONTyped(value?: CreatePalSubmissionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_oon': value['is_oon'],
    };
}

